<template>
  <section id="blog" class="section">
    <div class="content-670">
      <h2 class="title">NOTICIAS</h2>
      <div class="section-des">Información relacionada con la tecnología.</div>
      <p>Aquí podrás encontrar un listado de las noticias que pienso son relevantes, con respecto a la tecnología y el mundo en general.</p>
      <section v-if="errored">
        <p>Lo sentimos, no es posible obtener la información en este momento, por favor intente nuevamente mas tarde</p>
      </section>
      <section v-else>
        <div v-if="loading">Cargando...</div>
        <ul id="page-blog" v-if="listNews != null" class="home-blog-list">
          <li v-for="(obj, index) in listNews" :key="index">
            <a v-bind:href="obj.url" target="_blank" rel="noopener">{{obj.title}}</a>
            <div class="blog-list-info">
              <div class="date">{{obj.publishedAt.substring(0,10)}}</div>
              <div class="category">{{obj.source.name}}</div>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "page-blog",
  mounted() {
    this.getNews();
  },
  data() {
    return {
      msn: "Pagína Blog",
      loading: true,
      errored: false,
      listNews: null,

      country: "us",
      language: "es",
      sortBy: "publishedAt",
      category: "technology",
      q: "tecnología AND technology",
      pageSize: 10,
      page: 1,
      apiKey: "13fa175da3944c36800497d661028593"
    };
  },
  methods: {
    getNews() {
      var url = "https://newsapi.org/v2/everything?";
      url =
        url +
        //"country=" +
        //this.country +
        //"&category=" +
        //this.category +
        "language=" +
        this.language +
        "&q=" +
        this.q +
        "&pageSize=" +
        this.pageSize +
        "&page=" +
        this.page +
        "&apiKey=" +
        this.apiKey;
      url = url.toString().replace(/ /g, "%20");
      url = url.toString().replace(/í/g, "%C3%AD");
      //console.log("url = " + url);
      axios
        .get(url)
        .then(request => {
          const html = request.data;
          //console.log("Status = " + html.status + " totalResult " + html.totalResults);
          if (html.status == "ok" && html.totalResults != "0") {
            this.listNews = html.articles;
          } else {
            this.error = true;
          }
          //console.log(html);
          //this.listNews = request.data.data;
        })
        .catch(() => {
          //console.log("error:" + error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
